"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_082117ff{position:relative;padding:5px 38px}.root_082117ff .ms-Link{font-size:12px}\n" }]);
exports.root = "root_082117ff";
//# sourceMappingURL=GroupFooter.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupFooter.scss.js
// module id = 937
// module chunks = 0